import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Conceptos } from '@p-p-portafolio/interfaces/conceptos';
import { ConceptosService } from '@p-p-portafolio/services/conceptos.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-conceptos-form',
  templateUrl: './conceptos-form.component.html',
  providers: [MessageService]
})
export class ConceptosFormComponent implements OnInit, OnChanges {
  @Input() model: Conceptos | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private conceptosService: ConceptosService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (changes['model'].currentValue) {
        this.loadConcepto();
      } else {
        this.initForm();
      }
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      concepto: [{ value: '', disabled: !!this.model }, [Validators.required]],
      descripcion: ['', [Validators.required]],
      aplicaPagoMinimo: [0, [Validators.required]],
      aplicaSaldoPromedio: [0, [Validators.required]],
      integraConsumo: [0, [Validators.required]]
    });
  }

  loadConcepto(): void {
    if (!this.model) return;
    
    this.form.patchValue({
      concepto: this.model.concepto,
      descripcion: this.model.descripcion,
      aplicaPagoMinimo: this.model.aplicaPagoMinimo,
      aplicaSaldoPromedio: this.model.aplicaSaldoPromedio,
      integraConsumo: this.model.integraConsumo
    });
    this.form.get('concepto')?.disable();
  }

  create(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 1,
      tope: '',
      numero: formData.concepto,
      descripcion: formData.descripcion,
      aplicaSaldoMinimo: formData.aplicaPagoMinimo,
      aplicaSaldoPromedio: formData.aplicaSaldoPromedio,
      integraConsumo: formData.integraConsumo
    };

    this.conceptosService.saveConcepto(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Concepto creado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.errors?.[0] || 'Error al crear el concepto'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al crear el concepto'
        });
        this.loading = false;
      }
    });
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 2,
      tope: '',
      numero: formData.concepto,
      descripcion: formData.descripcion,
      aplicaSaldoMinimo: formData.aplicaPagoMinimo,
      aplicaSaldoPromedio: formData.aplicaSaldoPromedio,
      integraConsumo: formData.integraConsumo
    };

    this.conceptosService.updateConcepto(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Concepto actualizado correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.errors?.[0] || 'Error al actualizar el concepto'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar el concepto'
        });
        this.loading = false;
      }
    });
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'Conceptos',
        sClave: `${this.form.get('concepto')?.value}`,
        sNombre: this.form.get('descripcion')?.value,
        sTipo: 'Opcion'
      }
    });
  }

  isConceptoPrincipal(concepto: number): boolean {
    return concepto >= 1 && concepto <= 4;
  }
} 